import { roundNumber } from 'shared/utils/helpers/roundNumber';

export const getUserBalanceToCharge = (useUserBalance: boolean, userBalance: number, totalToPay: number): number => {
  return useUserBalance ? roundNumber(Math.min(totalToPay, userBalance)) : 0;
};
